module.exports = __webpack_public_path__ + "static/media/SF_bm_engl_primaerlogo_nordland_pos.5a4a9324.pdf";